import { z } from "zod";
import { ANNOUNCEMENT_SEVERITIES } from "./content.js";
import { plainTextField } from "./public-api.js";
import { promotionCtaInputSchema } from "./promotion-cta.js";
import { isPublicUploadPath } from "./image-upload.js";
import { scheduleFieldsSchema } from "./scheduling.js";
import { contentTargetingBaseSchema } from "./content-targeting.js";
const promotionImageFieldsSchema = z.object({
    imagePath: z
        .string()
        .nullable()
        .optional()
        .refine((v) => v == null || v === "" || isPublicUploadPath(v), "Invalid image path"),
    imageAlt: plainTextField(120).optional().default(""),
});
export const createAnnouncementDraftSchema = z
    .object({
    title: plainTextField(120),
    body: plainTextField(500),
    severity: z.enum(ANNOUNCEMENT_SEVERITIES),
    dismissible: z.boolean().default(false),
    /** C4B: structured emergency announcement (L1). Requires endsAt ≤ 24h. */
    emergency: z.boolean().optional().default(false),
    /** platform = all sites (platform owner only); organization = tenant-scoped targeting */
    emergencyAudience: z.enum(["organization", "platform"]).optional().default("organization"),
})
    .merge(contentTargetingBaseSchema)
    .merge(scheduleFieldsSchema);
export const updateAnnouncementDraftSchema = createAnnouncementDraftSchema.partial();
export const publishContentSchema = z.object({
    password: z.string().min(1).max(128),
});
export const rollbackContentSchema = z.object({
    snapshotId: z.string().min(1),
    password: z.string().min(1).max(128),
});
export const createPromotionDraftSchema = z
    .object({
    title: plainTextField(120),
    body: plainTextField(500),
    badge: plainTextField(40).optional().default(""),
})
    .merge(promotionCtaInputSchema)
    .merge(promotionImageFieldsSchema)
    .merge(contentTargetingBaseSchema)
    .merge(scheduleFieldsSchema);
export const updatePromotionDraftSchema = createPromotionDraftSchema.partial();
//# sourceMappingURL=content-api.js.map